import { render } from "./CRMDashboardCRMAgentSummaryComponent.vue?vue&type=template&id=b6443be4&scoped=true"
import script from "./CRMDashboardCRMAgentSummaryComponent.vue?vue&type=script&lang=js"
export * from "./CRMDashboardCRMAgentSummaryComponent.vue?vue&type=script&lang=js"

import "./CRMDashboardCRMAgentSummaryComponent.vue?vue&type=style&index=0&id=b6443be4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6443be4"]])

export default __exports__